export default __webpack_public_path__ + "static/media/wstDOT.63d27f89.svg";